import { render, staticRenderFns } from "./provider-list.vue?vue&type=template&id=57203fd9&scoped=true&lang=pug&"
import script from "./provider-list.vue?vue&type=script&lang=js&"
export * from "./provider-list.vue?vue&type=script&lang=js&"
import style0 from "./provider-list.vue?vue&type=style&index=0&id=57203fd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57203fd9",
  null
  
)

export default component.exports